import React from "react"; 

const Searchbar = () => 
    <div className="search center">
        <input type="text" placeholder="Enter search term" /> 
    </div> 

export default Searchbar; 


// WEBPACK FOOTER //
// ./src/components/searchbar.js